module.exports = __webpack_public_path__ + "static/media/Heating.52797ec0.jpeg";